import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/home/play.png'
import _imports_1 from '@/assets/home/game_arrow_white.png'
import _imports_2 from '@/assets/home/down_arrow.png'


const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "game-slider-container" }

import { computed, inject, onMounted, ref } from 'vue'
import { PropType } from 'vue'
import GameCard from '../../game/components/gameCard.vue';
import { playClickSound } from '@/utils/media';
import { useRouter } from 'vue-router';
import { GameGroupData, GameList, goToPlayGame } from '@/view/home/supportScript';


export default /*@__PURE__*/_defineComponent({
  __name: 'gamePanel',
  props: {
    gameList: {
        type: Array as PropType<GameList[]>,
        required: true
    },
    groupImage: {
        type: String,
        default: ''
    },
    groupName: {
        type: String,
        default: ''
    },
    itemData: {
        type: Object as PropType<GameGroupData>,
        required: true
    }

},
  emits: [ 'goGamePannel'],
  setup(__props, { emit: __emit }) {

const gameGrid = ref({
    rowCount: 0,
    columnCount: 0
})
const customStyles = ref({
    active_font_color: '',
    border_color: ""
})
const props = __props
const router = useRouter()
const gameCount = computed(() => props.gameList.length);
const openRegisterLoginPopup = inject<(type: number) => void>('openRegisterLoginPopup')
const emits = __emit
const currentPage = ref(0)
const pageSize = computed(() => {
    return gameGrid.value.rowCount * gameGrid.value.columnCount
})

const totalPages = computed(() => {
    return Math.ceil(props.gameList.length / pageSize.value)
})

const paginatedGameList = computed(() => {
    const start = currentPage.value * pageSize.value
    return props.gameList.slice(start, start + pageSize.value)
})

const nextPage = () => {
    if(process.env.VUE_APP_PREVIEW_MODE == 'true'){ return }
    if (currentPage.value < totalPages.value - 1) {
        playClickSound()
        currentPage.value++
    }
}

const prevPage = () => {
    if(process.env.VUE_APP_PREVIEW_MODE == 'true'){ return }
    if (currentPage.value > 0) {
        playClickSound()
        currentPage.value--
    }
}
const GoToPlayGame = (id: any, makerId: any, favorite: number, favId:number) => {
  goToPlayGame(router, openRegisterLoginPopup, id, makerId, favorite, favId)
}
onMounted(() => {
    gameGrid.value.rowCount = props.itemData.gamesGrid.rowCount
    gameGrid.value.columnCount = props.itemData.gamesGrid.columnCount
    customStyles.value.active_font_color = props.itemData.styles.active_font_color
    customStyles.value.border_color = props.itemData.styles.border_color
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_grid_item = _resolveComponent("van-grid-item")!
  const _component_van_grid = _resolveComponent("van-grid")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["panel_container", { pp_group: props.groupName === 'PP' }]),
    style: _normalizeStyle({ color: customStyles.value.active_font_color })
  }, [
    _createVNode(_component_van_row, {
      justify: "space-between",
      style: {"margin-bottom":"10px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "1",
          class: "left-borer"
        }),
        _createVNode(_component_van_col, {
          span: "15",
          class: "group_col"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: props.groupImage,
              alt: ""
            }, null, 8, _hoisted_1),
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = () => emits('goGamePannel')),
              class: "game_count",
              style: _normalizeStyle({ color: customStyles.value.border_color, border: `0.5px solid ${customStyles.value.border_color}` })
            }, _toDisplayString(gameCount.value), 5)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "8",
          class: "group_col_right"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "more_button",
              onClick: _cache[1] || (_cache[1] = () => emits('goGamePannel'))
            }, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('common.more')), 1),
              _cache[3] || (_cache[3] = _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              }, null, -1))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "arrow left",
        onClick: prevPage
      }, _cache[4] || (_cache[4] = [
        _createElementVNode("img", {
          src: _imports_1,
          alt: ""
        }, null, -1)
      ])),
      _createElementVNode("div", {
        class: "arrow right",
        onClick: nextPage
      }, _cache[5] || (_cache[5] = [
        _createElementVNode("img", {
          src: _imports_1,
          alt: ""
        }, null, -1)
      ])),
      _createVNode(_component_van_grid, {
        "column-num": gameGrid.value.columnCount,
        gutter: 2,
        border: false
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedGameList.value, (item) => {
            return (_openBlock(), _createBlock(_component_van_grid_item, {
              key: item.id
            }, {
              default: _withCtx(() => [
                _createVNode(GameCard, {
                  gameImage: item.customIcon,
                  gameTypeId: item.id,
                  gameIsFavorite: item.isFavorite,
                  onClickGameCard: ($event: any) => (GoToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite,item.id))
                }, null, 8, ["gameImage", "gameTypeId", "gameIsFavorite", "onClickGameCard"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["column-num"])
    ]),
    _createElementVNode("div", {
      class: "bottom_text",
      onClick: _cache[2] || (_cache[2] = () => emits('goGamePannel'))
    }, [
      _createTextVNode(_toDisplayString(_ctx.$t('common.loadMore')) + " ", 1),
      _cache[6] || (_cache[6] = _createElementVNode("img", {
        src: _imports_2,
        alt: ""
      }, null, -1))
    ])
  ], 6))
}
}

})